import { Entry } from '../Entry'

export function Entry20221012() {
  return (
    <Entry title="12/10/2022 - v3.2.8">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12785/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
